(() => {
  if (customElements.get('look-product-carousel')) return;
  let cartSnapshot = null;
  let cartExpanded = false;
  let visitorSeed;
  try {
    visitorSeed = localStorage.getItem('matilde-look-seed');
    if (!visitorSeed) {
      visitorSeed = crypto.getRandomValues(new Uint32Array(2)).join('-');
      localStorage.setItem('matilde-look-seed', visitorSeed);
    }
  } catch (_) { visitorSeed = String(Math.random()); }
  const productRank = (id, epoch = Math.floor(Date.now() / 3600000)) => {
    let hash = 2166136261;
    for (const character of visitorSeed + ':' + epoch + ':' + id) hash = Math.imul(hash ^ character.charCodeAt(0), 16777619);
    return hash >>> 0;
  };
  customElements.define('look-product-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) { this.startAuto(); return; }
      this.initialized = true;
      this.index = 0;
      this.restoreCartSelection();
      const disclosure = this.querySelector('.look-carousel__disclosure');
      if (disclosure) {
        disclosure.open = cartExpanded;
        disclosure.addEventListener('toggle', () => { cartExpanded = disclosure.open; });
      }
      this.userPaused = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') this.hovered = true; });
      this.addEventListener('pointerleave', () => { this.hovered = false; });
      this.addEventListener('pointerdown', () => { this.pauseUntil = Date.now() + 15000; }, { passive: true });
      this.addEventListener('change', () => { this.pauseUntil = Date.now() + 15000; });
this.startAuto();
      // Touch uses native scrolling; mouse dragging moves the same card row.
      this.addEventListener('dragstart', event => {
        if (this.nativeScroll() && event.target.closest('.look-carousel__cards')) event.preventDefault();
      });
      this.addEventListener('pointerdown', event => {
        if (!this.nativeScroll() || event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('select,button,input,label')) return;
        const track = event.target.closest('.look-carousel__cards');
        if (!track) return;
        this.cardDrag = { track, id: event.pointerId, x: event.clientX, left: track.scrollLeft, moved: false };
      });
      this.addEventListener('pointermove', event => {
        const drag = this.cardDrag;
        if (!drag || drag.id !== event.pointerId) return;
        const distance = event.clientX - drag.x;
        if (!drag.moved && Math.abs(distance) < 5) return;
        if (!drag.moved) {
          drag.moved = true;
          drag.track.classList.add('is-dragging');
          drag.track.setPointerCapture(event.pointerId);
        }
        drag.track.scrollLeft = drag.left - distance;
        event.preventDefault();
      });
      const finishCardDrag = event => {
        const drag = this.cardDrag;
        if (!drag || drag.id !== event.pointerId) return;
        this.cardDrag = null;
        if (!drag.moved) return;
        this.suppressClickUntil = Date.now() + 450;
        const cards = [...drag.track.querySelectorAll('[data-look-card]')];
        const left = drag.track.scrollLeft;
        const firstOffset = cards[0]?.offsetLeft || 0;
        const closest = cards.reduce((best, card) => Math.abs(card.offsetLeft - firstOffset - left) < Math.abs(best.offsetLeft - firstOffset - left) ? card : best, cards[0]);
        drag.track.classList.remove('is-dragging');
        if (drag.track.hasPointerCapture(event.pointerId)) drag.track.releasePointerCapture(event.pointerId);
        if (closest) drag.track.scrollTo({ left: closest.offsetLeft - firstOffset, behavior: this.userPaused ? 'auto' : 'smooth' });
      };
      this.addEventListener('pointerup', finishCardDrag);
      this.addEventListener('pointercancel', finishCardDrag);
      this.addEventListener('lostpointercapture', finishCardDrag);
      this.addEventListener('click', event => {
        if (Date.now() < (this.suppressClickUntil || 0)) { event.preventDefault(); event.stopImmediatePropagation(); }
      }, true);
      this.addEventListener('pointerdown', event => {
        this.gesture = null;
        if (this.nativeScroll() || !event.isPrimary || event.pointerType === 'mouse' || !event.target.closest('.look-carousel__cards') || event.target.closest('select,button,input,label')) return;
        this.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY };
      });
      this.addEventListener('pointercancel', () => { this.gesture = null; });
      this.addEventListener('pointerup', event => {
        const start = this.gesture;
        this.gesture = null;
        if (!start || start.id !== event.pointerId) return;
        const dx = event.clientX - start.x, dy = event.clientY - start.y;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.4) return;
        this.suppressClickUntil = Date.now() + 450;
        this.move(dx < 0 ? 1 : -1);
      });
      this.addEventListener('click', event => {
        const arrow = event.target.closest('[data-look-direction]');
        if (arrow) this.move(Number(arrow.dataset.lookDirection));
        const button = event.target.closest('[data-look-add]');
        if (button) this.add(button);
      });
      this.addEventListener('change', event => {
        if (!event.target.matches('[data-look-variant]')) return;
        const card = event.target.closest('[data-look-card]');
        const option = event.target.selectedOptions[0];
        card.querySelector('[data-look-price]').textContent = option.dataset.price;
        const compare = card.querySelector('[data-look-compare]');
        compare.textContent = option.dataset.compare || '';
        compare.hidden = !option.dataset.compare;
        const saving = card.querySelector('[data-look-saving]');
        if (saving) { saving.textContent = option.dataset.saving || ''; saving.hidden = !option.dataset.saving; }
        const image = card.querySelector('img');
        if (image && option.dataset.image) { image.removeAttribute('srcset'); image.src = option.dataset.image; }
      });
    }
    disconnectedCallback() {
      clearInterval(this.autoTimer);
      this.visibilityObserver?.disconnect();
      this.refreshController?.abort();
      if (this.mobileQuery) this.mobileQuery.onchange = null;
    }
    nativeScroll() { return this.dataset.context === 'cart'; }
    cartOpen() { return Boolean(document.querySelector('matilde-cart dialog[open]')); }
    interacting() {
      return this.busy || document.querySelector('matilde-cart')?.busy || this.hovered || Date.now() < (this.pauseUntil || 0) || (this.contains(document.activeElement) && document.activeElement.matches('select,input'));
    }
    restoreCartSelection() {
      if (this.dataset.context !== 'cart') return;
      const container = this.querySelector('.look-carousel__cards');
      [...container.children]
        .sort((first, second) => productRank(first.dataset.productId) - productRank(second.dataset.productId))
        .forEach(card => container.append(card));
      if (cartSnapshot && (this.cartOpen() || cartSnapshot.epoch === Math.floor(Date.now() / 3600000))) {
        container.innerHTML = cartSnapshot.html;
        this.dataset.batch = cartSnapshot.batch;
        const excluded = new Set(JSON.parse(this.dataset.excluded || '[]').map(String));
        container.querySelectorAll('[data-look-card]').forEach(card => { if (excluded.has(card.dataset.productId)) card.remove(); });
        [...container.children].forEach(card => { card.hidden = false; });
        this.hidden = !container.children.length;
      } else {
        cartSnapshot = { html: container.innerHTML, batch: this.dataset.batch, epoch: Math.floor(Date.now() / 3600000) };
      }
    }
    startAuto() {
      clearInterval(this.autoTimer);
      if (this.nativeScroll()) {
        this.warmImages();
        this.nextRefresh = ((cartSnapshot?.epoch ?? Math.floor(Date.now() / 3600000)) + 1) * 3600000;
        this.autoTimer = setInterval(() => this.tick(), 30000);
        return;
      }
      this.mobileQuery ||= matchMedia('(max-width: 768px)');
      this.mobileQuery.onchange = () => {
        this.renderCards();
        this.querySelector('.look-carousel__cards').scrollLeft = 0;
      };
      this.visibilityObserver?.disconnect();
      this.visibilityObserver = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        if (this.visible) this.warmImages();
      }, { rootMargin: '200px' });
      this.visibilityObserver.observe(this);
      this.nextAdvance = Date.now() + 5000;
      this.nextRefresh = (Number(this.dataset.batch) + 1) * 600000 || Date.now() + 600000;
      this.warmImages();
      this.autoTimer = setInterval(() => this.tick(), 1000);
    }
    renderCards() {
      const container = this.querySelector('.look-carousel__cards');
      const cards = [...container.querySelectorAll('[data-look-card]')];
      container.classList.toggle('has-next', cards.length > 1);
      if (this.nativeScroll()) {
        cards.forEach(card => {
          card.classList.remove('is-current', 'is-next');
          card.hidden = false;
          card.inert = false;
          card.removeAttribute('aria-hidden');
        });
        return;
      }
      cards.forEach((card, index) => {
        const current = index === this.index;
        card.classList.toggle('is-current', current);
        card.classList.toggle('is-next', cards.length > 1 && index === (this.index + 1) % cards.length);
        const accessible = this.nativeScroll() || current;
        card.hidden = !accessible;
        card.inert = !accessible;
        if (accessible) card.removeAttribute('aria-hidden');
        else card.setAttribute('aria-hidden', 'true');
      });
    }
    warmImages() {
      this.renderCards();
      const cards = [...this.querySelectorAll('[data-look-card]')];
      if (!cards.length || (this.nativeScroll() ? !this.cartOpen() : !this.visible)) return;
      for (const offset of [0, 1, 2, 3, 4, -1]) {
        const image = cards[(this.index + offset + cards.length) % cards.length].querySelector('img');
        if (!image) continue;
        image.loading = 'eager';
        image.decoding = 'async';
      }
    }
    tick() {
      if (document.hidden || !this.isConnected) return;
      const now = Date.now();
      if (now >= this.nextRefresh && (this.nativeScroll() || this.visible) && !this.cartOpen() && !this.interacting() && !this.refreshing) this.refreshSelection();
      if (this.nativeScroll() || !this.visible || this.userPaused || this.interacting() || (this.dataset.context === 'cart' && !this.cartOpen())) { this.nextAdvance = now + 5000; return; }
      if (now >= this.nextAdvance) { this.move(1, true); this.nextAdvance = now + 5000; }
    }
    async refreshSelection() {
      if (this.cartOpen() || this.refreshing) return;
      this.refreshing = true;
      this.refreshController = new AbortController();
      const timeout = setTimeout(() => this.refreshController.abort(), 15000);
      try {
        const url = new URL(this.dataset.sourceUrl || location.pathname, location.origin);
        url.searchParams.set('section_id', 'look-carousel-feed');
        url.searchParams.set('_look', Date.now());
        const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: this.refreshController.signal });
        if (!response.ok) throw new Error('Recommendations unavailable');
        const html = await response.text();
        if (!this.isConnected || this.cartOpen() || this.interacting()) return;
        const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('look-product-carousel');
        if (!fresh) { this.nextRefresh = Date.now() + 600000; return; }
        this.querySelector('.look-carousel__cards').innerHTML = fresh.querySelector('.look-carousel__cards').innerHTML.replaceAll('look-feed-', 'look-' + this.dataset.context + '-');
        this.dataset.batch = fresh.dataset.batch;
        this.dataset.excluded = fresh.dataset.excluded;
        if (this.nativeScroll()) {
          const container = this.querySelector('.look-carousel__cards');
          [...container.children].sort((first, second) => productRank(first.dataset.productId) - productRank(second.dataset.productId)).forEach(card => container.append(card));
          container.scrollLeft = 0;
        }
        this.index = 0;
        this.warmImages();
        this.nextAdvance = Date.now() + 5000;
        this.nextRefresh = this.nativeScroll() ? (Math.floor(Date.now() / 3600000) + 1) * 3600000 : Date.now() + 600000;
        this.hidden = false;
        if (this.dataset.context === 'cart') cartSnapshot = { html: this.querySelector('.look-carousel__cards').innerHTML, batch: this.dataset.batch, epoch: Math.floor(Date.now() / 3600000) };
      } catch (_) { this.nextRefresh = Date.now() + 60000; }
      finally { clearTimeout(timeout); this.refreshing = false; }
    }
    move(direction, automatic = false) {
      if (this.busy || this.closest('matilde-cart')?.busy) return;
      if (this.nativeScroll()) {
        if (automatic) return;
        const track = this.querySelector('.look-carousel__cards');
        const card = track.querySelector('[data-look-card]');
        if (card) track.scrollBy({ left: direction * (card.getBoundingClientRect().width + 4), behavior: this.userPaused ? 'auto' : 'smooth' });
        return;
      }
      const cards = [...this.querySelectorAll('[data-look-card]')];
      if (cards.length < 2) return;
      const nextIndex = (this.index + direction + cards.length) % cards.length;
      const nextImage = cards[nextIndex].querySelector('img');
      if (nextImage) nextImage.loading = 'eager';
      if (automatic && nextImage && !nextImage.complete) return;
      this.index = nextIndex;
      cards.forEach((card, index) => { card.hidden = index !== this.index; });
      this.warmImages();
    }
    async add(button) {
      const cart = document.querySelector('matilde-cart');
      if (this.busy || cart?.busy) return;
      const error = this.querySelector('[data-look-error]');
      error.hidden = true;
      const card = button.closest('[data-look-card]');
      const id = Number(card.querySelector('[data-look-variant]')?.value || button.dataset.lookAdd);
      this.busy = true;
      button.disabled = true;
      try {
        if (cart?.run && cart?.request) {
          cart.open(button);
          await cart.run(async () => {
            await cart.reconcile(await cart.request('cart/add.js', { items: [{ id, quantity: 1 }] }));
            cart.pendingFocus = () => (cart.querySelector('look-product-carousel [data-look-direction]') || cart.querySelector('[data-mc-checkout]'))?.focus({ preventScroll: true });
          });
        } else {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id, quantity: 1 }] }) });
          if (!response.ok) throw new Error(this.dataset.error);
          location.assign(root + 'cart');
        }
      } catch (failure) {
        error.textContent = failure.message || this.dataset.error;
        error.hidden = false;
      } finally { this.busy = false; button.disabled = false; }
    }
  });
})();
